module.exports = __webpack_public_path__ + "static/img/4-4.2778ddd.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/4-4.png
// module id = 271
// module chunks = 0